import Keycloak from 'keycloak-js';
import {configuration} from '../../config/configuration';

export const keycloak = Keycloak({
    url: configuration.keycloakUrl,
    realm: configuration.keycloakRealm,
    clientId: configuration.keycloakClientId
});
